module.exports = "/images/aerial-11.jpg";